import { VroongShippingLabelResponse } from '@/apis/pharmacy/interface';

export const printVroongShippingLabelwithZPL = ({
  invoiceId,
  shippingDate,
  transportRoundName,
  orderId,
  items,
  routingInfo,
  departureInfo,
  destinationInfo
}: VroongShippingLabelResponse) => {
  const replaceInvoiceId = (invoiceId: string) => {
    return invoiceId.replaceAll('-', '');
  };

  return `^XA
^PW800
^LH0,18
^CF0,19
^CW0,E:NANUMB.TTF^CI28^FS

-- VROONG LOGO
^FO100,10^GFA,1716,1716,11,,::::::::M02,M0FF,K010FF8,K030FFC,K078FFE,K0F8IF,K0FCIF8,K0FEIF8,J01FCF9F8,J01FCF9FC,J01F8F9FC,J01F801FC,J01FC01FC,J01FC01F8,K0FE03F8,K0FF8FF8,K0KF,K07JF,K03IFE,K01IFC,L0IF8,L03FE,,:K0KF8,::K0KF80010F,K0KF80019F8,K0KF80039F8,L027FFI03998,M07FEI03F98,M0FFCI01F18,L03FF8I01F38,L07FEK0E1,L0FFC,K03FF8,K07FFK0183,K0KF8001C38,K0KF8001838,K0KF8003818,:K0KF8001838,K0KF8001C78,K0KF8001FF,T0FE,M0F8K038,L07FF,L0IF8007,K03IFC0079FF8,K03IFE0071FF8,K07JF002,K0KF8,K0FF0FF8001008,J01FE03F8001818,J01FC01F8001818,J01FC01FC003838,J01F801FC01IF8,J01FC01FC01IF,J01FC01F80038,J01FE03F80018,K0FF07F80018,K0KF8,K07JF,K07IFEI010F,K03IFEI019F8,K01IFCI039F8,L07FFJ03B98,L01FCJ03F98,S01F18,L01FCJ01F38,L07FFL01,K01IFC,K03IFE003162,K07JF0071FF8,K07JF0079FF8,K0KF803,K0FF07F8,J01FE03F8,J01FC01F8,J01FC01FC001IF,J01F801FC001IF8,J01FC01FC001C7BC,J01FC01F8001839C,J01FE03F8003818C,K0FF8FF8003818C,K0KFI03838C,K07JFI01E79C,K03IFEI01FF1C,K01IFCJ0FE08,L0IF8,L03FE,M0FL07E,K07C01F8I0FF,K07E03F8001EF8,K0FE07F8001C38,K0FE0FF8003818,K0FE1FF8003818,K0FE3FFI03838,K0FE7FEI01C38,K0FEFFCI01FF,K0JF8J0FF,K0JFK07C,K0IFE,K0IFCL018,K0IF8L018,K0KFK018,K0KF8J018,::K0KF803IF8,::,K0C,K0F,K0FC,K0FF,K0FFE,K0IF,K0IFE,K0JF8,K03IFE,L07IF8,L01IF8,M07FF8,M01FF8,M0IF8,L03IF8,K01JF,K07IFE,K0JF,K0IFC,K0IF,K0FFC,K0FE,K0F8,K0E,K08,,:::::::^FS

^FX -- 운송일자
^AJB,25
^FO33,15
^FD
${shippingDate}
^FS

^FX -- 송장번호
^FO33,0,0
^FB880,1,10,L,0
^AJB,25,25,^FH^FD
${invoiceId}
^FS

^FX -- 상단 QR CODE
^FO70,850
^BQN,2,4
^FDHA,
${replaceInvoiceId(invoiceId)}
^FS

^FX -- 센터명 BackGround
^LRY
^FO68,610
^GB100,240,55
^FS

^FX -- 센터명
^FO80,0,0
^FB835,2,10,L,0
^AJB,95,60,^FH^FD
${routingInfo.deliveryCenter}
^FS
 
^FX -- 운송타입 BackGround
^LRY
^FO68,247
^GB80,158,55
^FS
 
^FX -- 운송타입 + 회차
^FO75,0,0
^FB600,2,10,L,0
^AJB,50,40.8,^FH^FD
${transportRoundName}
^FS

^FX -- 지점
^AJB,30
^FO155,190
^FD
${routingInfo.serviceStationName}
^FS

^FX -- 간선코드
^AJB,90
^FO70,190
^FD
${routingInfo.lineHaulCode}
^FS

^FX -- 화주사 주문번호
^FO710,0,0
^FB950,1,10,L,0
^AJB,50,45.8,^FH^FD
${orderId}
^FS

^FX -- 하단 QR CODE
^FO650,10
^BQN,2,5
^FDHA,
${replaceInvoiceId(invoiceId)}
^FS

^FX -- BARCODE 128
^FO200,50
^BY2
^BCB,50,N,N,N,A
^FD
${routingInfo.lineHaulCode}
^FS

^FX -- 받는분
^FO213,0,0
^FB935,4,10,L,0
^AJB,30,30,^FH^FD
${destinationInfo.name}\\&
${destinationInfo.baseAddress} ${destinationInfo.detailAddress}
^FS

^FX -- 보내는분
^FO370,0,0
^FB935,2,5,L,0
^AJB,25,25,^FH^FD
${departureInfo.name} ${departureInfo.phone}\\&
${departureInfo.address}
^FS

^FX -- 상품정보
^FO440,0,0
^FB935,8,5,L,0
^AJB,25,25,^FH^FD
${items.map(
  ({ itemId, itemName, quantity }) => `[${itemId}] ${itemName} - ${quantity}개`
)}
^FS

^XZ`;
};
